import { useTranslation } from 'react-i18next'

import { FormModal } from '../../../Form'

import { REQUEST_PROFILE_TAB_EMAILS_MOVE_TO_TAB_FIELD_NAME } from './RequestProfileTabEmailsMoveToTabModal.constants'
import {
  getRequestProfileTabEmailsMoveToTabInitialValues,
  getRequestProfileTabEmailsMoveToTabOptions,
  getRequestProfileTabEmailsMoveToTabValidationSchema,
} from './RequestProfileTabEmailsMoveToTabModal.utils'
import { RequestProfileTabEmailsMoveToTabModalFields } from './RequestProfileTabEmailsMoveToTabModalFields'

function RequestProfileTabEmailsMoveToTabModal({
  currentAudience,
  onClose,
  onSubmit,
}) {
  const { t } = useTranslation()

  const options = getRequestProfileTabEmailsMoveToTabOptions({ t })

  const initialValues = getRequestProfileTabEmailsMoveToTabInitialValues({
    currentAudience,
    options,
  })

  const validationSchema =
    getRequestProfileTabEmailsMoveToTabValidationSchema(initialValues)

  function handleSubmit({ values }) {
    onSubmit(values[REQUEST_PROFILE_TAB_EMAILS_MOVE_TO_TAB_FIELD_NAME].value)
  }

  return (
    <FormModal
      Fields={RequestProfileTabEmailsMoveToTabModalFields}
      formBodyProps={{
        submitButtonText: 'Modal.RequestProfileTabEmailsMoveToTabSubmitKey',
        withNotifications: true,
      }}
      formFieldsProps={{ options }}
      formTitle='Modal.RequestProfileTabEmailsMoveToTabTitleKey'
      initialValues={initialValues}
      validationSchema={validationSchema}
      onClose={onClose}
      onSubmit={handleSubmit}
    />
  )
}

export default RequestProfileTabEmailsMoveToTabModal
